import {createRouter, createWebHistory} from 'vue-router'
import routes from 'vue-auto-routing'
import {createRouterLayout} from 'vue-router-layout'
import store from "@/store";
import {Mutations, Actions} from "@/store/enum/StoreEnums";
import Middleware from "@/middleware";

const RouterLayout = createRouterLayout(layout => {
    return import('@/layouts/' + layout + '.vue')
})

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            redirect: "/dashboard",
            component: RouterLayout,
            children: routes
        }
    ]
})

router.beforeEach((to, from, next) => {
    // reset config to initial state
    store.commit(Mutations.RESET_LAYOUT_CONFIG);

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);

    const middleware = Middleware.loadMiddlewares(to.meta);

    if(middleware && middleware.length) {
        const context = {from, next, router, store, to};
        return Middleware.runMiddleware({...context});
    }

    return next();
});


export default router
